import { PANEL_TYPES, PANEL_STATES } from "../projectWizardConstants.js";
import { OPERATIONS } from "../../../../constants/operations.js";

import * as Yup from "yup";
import * as Schemas from "../../../../components/forms/validationSchemas.js";

import { resourceBlockValidationSchema } from "../../../../components/projectWizard/resourcePanel/resourceBlockValidationSchema.js";

export default {
  id: "add-workstations",
  type: "ADD_WORKSTATIONS",
  copyKey: "project_wizard.config_copy.add_workstations",
  modalCopyKey: "project_wizard.config_copy.add_workstations.modals",

  initialValues: {
    provider: null,
    region: null,
    zone: null,

    workstations: []
  },

  estimateConditions: ["resources"],

  steps: [
    {
      id: "resources",
      name: "Add Workstations",
      icon: "desktop",
      defaultEstimatePanel: false,
      panels: [
        {
          id: "providers",
          panelType: PANEL_TYPES.PROVIDER,
          permissionType: OPERATIONS.LIST,
          required: true,
          view: PANEL_STATES.ACTIVE
        },
        {
          id: "regions",
          panelType: PANEL_TYPES.REGION,
          permissionType: OPERATIONS.LIST,
          required: true,
          view: PANEL_STATES.INACTIVE,
          dependencies: [
            {
              name: "provider",
              view: PANEL_STATES.ACTIVE
            }
          ]
        },
        {
          id: "workstations",
          panelType: PANEL_TYPES.WORKSTATION,
          permissionType: OPERATIONS.CREATE,
          required: true,
          view: PANEL_STATES.ACTIVE,
          dependencies: [
            {
              name: "region",
              view: PANEL_STATES.ACTIVE
            }
          ]
        },
        {
          id: "estimate",
          panelType: PANEL_TYPES.ESTIMATE,
          view: PANEL_STATES.ACTIVE
        }
      ],
      panelDependencyIndex: ["provider", "region"],
      validationSchema: function (messages) {
        const objShape = {
          projectId: Yup.mixed().required(),
          provider: Schemas.dropdownSchema("Provider", messages),
          region: Schemas.dropdownSchema("Location", messages),
          zone: Schemas.dropdownSchema("Zone", messages, false),
          workstations: Yup.array().of(resourceBlockValidationSchema(messages))
        };
        return Yup.object().shape(objShape, ["projectId"]);
      }
    }
  ]
};
